export const SKILL_1 = "Schilderen";
export const SKILL_2 = "Zingen";
export const SKILL_3 = "Koken";

export const SKILLS = [
  { id: SKILL_1, nl: "Schilderen", en: "Painting" },
  { id: SKILL_2, nl: "Zingen", en: "Singing" },
  { id: SKILL_3, nl: "Koken", en: "Cooking" },
];
